import pino from 'pino';
import {appInsights} from "../AppInsights";
import {SeverityLevel} from "@microsoft/applicationinsights-common";

export const logger = pino({
    level: import.meta.env.VITE_LOGLEVEL,
    timestamp: () => `",time":"${new Date(Date.now()).toISOString()}"`,
    browser: {
        transmit: {
            level: 'info',
            send: function (level, logEvent) {
                appInsights.trackTrace({
                    message: JSON.stringify(logEvent.messages),
                    severityLevel: resolveSeverityLevel(level),
                });
            }
        }
    }
});

function resolveSeverityLevel(level: string) {
    switch (level) {
        case 'info': return SeverityLevel.Information;
        case 'warn': return SeverityLevel.Warning;
        case 'error': return SeverityLevel.Error;
        case 'fatal': return SeverityLevel.Critical;
        default: return SeverityLevel.Verbose;
    }
}
